import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {Navigasjon} from 'web-ng2/tjenester/Navigasjon';

export type AdministrasjonNavigasjonspunkt = 'soek' | 'avtaler' | 'brukere' | 'meldinger' | 'asynkOppgaver' | 'spoerreskjemaer';

@Component({
    selector: 'administrasjon-navigasjon',
    templateUrl: 'administrasjon-navigasjon.html',
    styleUrl: 'administrasjon-navigasjon.scss',
    imports: [MatButton, TranslateModule],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrasjonNavigasjonKomponent {
    aktiv = input.required<AdministrasjonNavigasjonspunkt>();

    constructor(private navigasjon: Navigasjon) {}

    gaaTil(punkt: AdministrasjonNavigasjonspunkt): void {
        switch (punkt) {
            case 'soek': this.navigasjon.gåTilAdministrasjonSøk(); break;
            case 'avtaler': this.navigasjon.gåTilAdministrasjonAvtaler(); break;
            case 'brukere': this.navigasjon.gåTilAdministrasjonBrukere(); break;
            case 'meldinger': this.navigasjon.gåTilAdministrasjonMeldinger(); break;
            case 'asynkOppgaver': this.navigasjon.gåTilAdministrasjonAsynkOppgaver(); break;
            case 'spoerreskjemaer': this.navigasjon.gåTilAdministrasjonSpørreskjemaer(); break;
        }
    }
}
